import { FontWeights } from '@uifabric/styling';
import {
    RecipientWellLabelWithContactPickerStyleProps,
    RecipientWellLabelWithContactPickerStyles,
} from './RecipientWellLabelWithContactPicker.types';

export const getStyles = (
    props: RecipientWellLabelWithContactPickerStyleProps
): RecipientWellLabelWithContactPickerStyles => {
    const { theme } = props;
    const { palette } = theme;
    const recipientSize = 32;

    return {
        root: [
            'RecipientWellLabelWithContactPicker',
            [
                {
                    selectors: {
                        ':hover .RecipientWellLabelWithContactPicker-label': {
                            backgroundColor: palette.themeLighter,
                        },
                        ':active .RecipientWellLabelWithContactPicker-label': {
                            backgroundColor: palette.themeLight,
                        },
                    },
                },
            ],
        ],
        label: [
            'RecipientWellLabelWithContactPicker-label',
            {
                display: 'inline-block',
                position: 'relative',
                height: recipientSize,
                lineHeight: recipientSize,
                margin: '11px 10px 0 0',
                minWidth: '52px',
                padding: '0 4px',
                textAlign: 'center',
                fontWeight: FontWeights.semibold,
                color: palette.themeDark,
                backgroundColor: palette.themeLighterAlt,
                borderRadius: '2px',
                cursor: 'pointer',
            },
        ],
    };
};
